import { z } from "zod"

export const GROUPINGS = ["manufacturer", "ata_chapter"] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const GROUPING_LABELS: Record<Grouping, string> = {
  manufacturer: "Manufacturer",
  ata_chapter: "ATA chapter",
}
